import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private http: HttpClient) { }

  upload(file: File, fieldname: string, description: string, professionalId: string): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('document', file);
    formData.append('fieldname', fieldname);
    formData.append('description', description);
    formData.append('professionalId', professionalId);

    const req = new HttpRequest('POST', `${environment.apiUrl}admin/files`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }
}
